<template>
  <div class="h-screen">
    <video
      id="background-video"
      loop
      muted
      autoplay
      playsinline
      class="relative w-full h-screen z-0 object-cover top-0 left-0"
    >
      <source
        src="../assets/video/exploded_and_closeup_fade.webm"
        type="video/webm"
      />
      <source
        src="../assets/video/exploded_and_closeup_fade.mp4"
        type="video/mp4"
      />
    </video>
    <div
      class="flex flex-col h-screen w-full absolute top-0 left-0 bg-black-transparent justify-items-end"
    >
      <div class=" w-full pr-20 flex-1">
        <a
          href="#"
          class="block w-20 h-20 mt-20 ml-auto lg:mt-32 md:h-32 md:w-32"
        >
          <img
            src="@/assets/img/macaronWhite.png"
            alt
            style="transform: rotate(20deg)"
          />
        </a>
      </div>
      <div
        class="container flex flex-col px-8 mx-auto lg:px-16 z-10 mb-8 sm:mb-16 md:mb-32"
      >
        <div class="flex flex-col w-full xl:w-2/3 justify-end">
          <!-- <Countdown
            class="text-center"
            starttime="Mar 5, 2020 20:00:00"
            endtime="Apr 7, 2020 20:00:00"
            trans='{
            "day":"Jours",
            "hours":"Heures",
            "minutes":"Minutes",
            "seconds":"Seconds",
            "expired":"",
            "running":"Avant la fin la campagne",
            "upcoming":"Avant le début de la campagne",
            "status": {
              "expired":"",
              "running":"",
              "upcoming":""
            }}'
          ></Countdown> -->
          <h1
            class="mt-4 text-3xl leading-tight text-center md:font-thin sm:text-left sm:text-4xl md:text-5xl font-raleway"
          >
            L'objet connecté de&nbsp;mon animal
          </h1>
          <!-- <div class="hidden sm:block"> -->
          <p
            class="flex flex-row items-center mt-4 mb-6 text-center lg:text-left"
          >
            <span class="flex-shrink-0 inline-block">
              <img
                v-if="thanks"
                src="@/assets/img/content.gif"
                class="w-auto h-16 mr-4"
                alt
              />
              <img
                v-if="dislike"
                src="@/assets/img/triste.gif"
                class="w-auto h-16 mr-4"
                alt
              />
            </span>
            {{ formText }}
          </p>
          <NewsletterForm
            v-if="!thanks && !dislike"
            :forceAngle="forceAngle"
            class="lg:max-w-lg"
          />
          <!-- </div> -->
        </div>
      </div>
      <a
        href="#"
        v-scroll-to="'#application'"
        class="mx-auto mb-6 text-sm text-center animation sm:text-base z-10 w-full"
      >
        <p>Que fait mon chat quand je ne suis pas là ?</p>
        <p class="font-semibold underline">Le découvrir ici</p>
        <svgScroll class="h-8 mx-auto mt-2 md:h-16" />
      </a>
    </div>
  </div>
</template>

<script>
import svgScroll from "../assets/svg/scroll.svg";
import NewsletterForm from "./NewsletterForm";
import Countdown from "./Countdown";

export default {
  name: "Hero",
  props: {
    forceAngle: {
      default: null,
      type: String,
    },
    thanks: {
      default: false,
      type: Boolean,
    },
    dislike: {
      default: false,
      type: Boolean,
    },
    // isGpsEnabled: {
    //   default: true,
    //   type: Boolean
    // }
  },
  computed: {
    formText: function() {
      if (this.thanks) {
        return "Merci !";
      } else if (this.dislike) {
        return "Merci de votre avis, nous le prenons en compte et espérons que vous allez aimer la prochaine !";
      } else {
        return "Inscrivez vous à la newsletter pour être au courant de notre actualité";
      }
    },
  },
  components: {
    svgScroll,
    NewsletterForm,
    Countdown,
  },
};
</script>

<style>
.bg-image {
  background-image: linear-gradient(
      to bottom,
      rgba(10, 10, 10, 0.4),
      rgba(0, 0, 0, 0)
    ),
    url("../assets/img/heroBanner.jpg");
}

.object-cover {
  object-fit: cover;
}

.bg-black-transparent {
  background-color: rgba(0, 0, 0, 0.4);
}
/* .animation {
    animation: updown 1.2s ease-in-out alternate infinite;
    backface-visibility: hidden;
  }

  @media (prefers-reduced-motion: reduce) {
    .animation {
      animation: none;
    }
  }
  @keyframes updown {
    from {
      transform: translateY(0) translateZ(0);
    }
    to {
      transform: translateY(10px) translateZ(0);
    }
  }
  @-moz-document url-prefix() {
    .animation {
        animation: none;
    }
  } */
</style>
